import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthenticated } from '~/components/authentication/ducks/selectors.js';
import { fetchIsStreamer, selectIsEventLive, selectIsStreamer } from '../ducks/we-spin-dashboard-duck.js';
import { setupWeSpinLiveEventSessionId } from '../ducks/we-spin-duck.js';

const useTakeMeToEvent = () => {
	const dispatch = useDispatch();

	const isStreamer = useSelector(selectIsStreamer);
	const isEventLive = useSelector(selectIsEventLive);
	const authenticated = useSelector(selectAuthenticated);
	const didLogin = useRef(authenticated);

	useEffect(() => {
		if (!authenticated) {
			didLogin.current = false;
		}
	}, [authenticated]);

	useEffect(() => {
		dispatch(fetchIsStreamer());
	}, [dispatch]);

	useEffect(() => {
		if (authenticated && isStreamer) {
			// upon login
			if (!didLogin.current) {
				// Setup we-spin if it's not test run
				if (typeof process === 'undefined' && !!isEventLive) {
					didLogin.current = true;
					dispatch(setupWeSpinLiveEventSessionId());
				}
			}
		}
	}, [dispatch, isEventLive, authenticated, isStreamer]);
};

export default useTakeMeToEvent;
